import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { API_URL } from '../../config';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private loggedIn = new BehaviorSubject<boolean>(false);
  isLoggedIn$ = this.loggedIn.asObservable();

  constructor(private router: Router, private http: HttpClient, private toastService: ToastService) {
    const storedLogin = localStorage.getItem('isLoggedIn');
    if (storedLogin === 'true') {
      this.loggedIn.next(true);
    }

  }



  createUser(dto: {
    email: string;
    encryptedPassword: string;
    firstName: string;
    lastName: string;
    phone?: string;
    iso?: string;
    countryCode?: string;
  }) {
    return this.http.post(`${API_URL}/users`, dto);
  }

  login(request: { email: string; password: string }) {
    return this.http.post(`${API_URL}/users/login`, request);
  }

  otpVerify(request: { email: string; otp: string }) {
    return this.http.post(`${API_URL}/users/verify-otp`, request);
  }

  sendOtp(email: string) {
    return this.http.post(`${API_URL}/users/send-otp`, email);
  }
  

  getUserById(id: string) {
    return this.http.get(`${API_URL}/users/${id}`); 
  }
  //   getAllUsers() {
  //   return this.http.get(`${API_URL}/users/all`);
  // }

  getAllUsers() {
    return this.http.get(`${API_URL}/users/all`);
  }

  resetPassword(request: { email: string; newPassword: string }) {
    return this.http.post(`${API_URL}/users/reset-password`, request);
  }

  setIsLoggedIn(isLoggedIn: boolean) {
    this.loggedIn.next(isLoggedIn);
  }

  // Clear all session data without navigation
  clearSession() {
    this.loggedIn.next(false);
    localStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('authToken');
    localStorage.clear();
    sessionStorage.clear();
  }

  // This will be called by our HeaderComponent
  signOut() {
    this.clearSession();
    this.router.navigate(['/auth/sign-in']);
    // this.toastService.show("logged out successfully", 'error')
  }



}
